import { Kamoku } from '@/repositories/fuzoku-meisai/data'
import { ResponseJunshisanSetting } from '@/repositories/fuzoku-meisai/junsoku/data'
import { Axios } from 'axios'
import { RootState } from '@/store'

export interface JunshisanSettingRepository {
  list (): Promise<ResponseJunshisanSetting>;
  save (param: ResponseJunshisanSetting): Promise<ResponseJunshisanSetting>;
}

type RequestJunshinsanSetting = {
  zandaka: Array<Kamoku>;
  junsoneki: Array<Kamoku>;
}

export class JunshisanSettingRepositoryImpl implements JunshisanSettingRepository {
  constructor (http: Axios, baseUri: string, state: RootState) {
    this.http = http
    this.baseUri = `${baseUri}/junshisan`
    this.state = state
  }

  private readonly http: Axios
  private readonly baseUri: string
  private readonly state: RootState

  async list (): Promise<ResponseJunshisanSetting> {
    const startDate = this.state.accountingStartDate
    const endDate = this.state.accountingEndDate

    const { data } = await this.http.get(
      this.baseUri,
      {
        params: {
          startDate: startDate,
          endDate: endDate
        }
      })
    return data
  }

  async save (param: ResponseJunshisanSetting): Promise<ResponseJunshisanSetting> {
    const request: RequestJunshinsanSetting = {
      zandaka: param.zandaka.targets,
      junsoneki: param.junsoneki.targets
    }

    const { data } = await this.http.post(this.baseUri, request)
    return data
  }
}
